import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getAuthToken } from 'helpers/cookie.helpers'
import {
  getAllFavouriteGames,
  getSearchedGames
} from 'redux-thunk/thunk/game.thunk'
import {
  CASINO_TABS,
  GAME_CATEGORY,
  LOADER_HANDLER_TYPES
} from 'constants/index'
import { setFilteredGames } from 'redux-thunk/redux/slices/games.slice'
import { openWarningToaster } from 'helpers/toaster.helpers'
import Loader from 'components/ui-kit/Loader/index'
import { GameImg } from 'pages/GameImage/index'
import ContentNotFound from 'components/ui-kit/ContentNotFound/index'

const FilteredGames = () => {
  const isLoggedIn = getAuthToken()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { user } = useSelector((state) => state.user)
  const { searchGame, gameCategory, provider, tab } = useSelector(
    (state) => state?.lobby
  )
  const { filteredGames } = useSelector((state) => state.games)
  const { [LOADER_HANDLER_TYPES.categoryWiseGamesList]: loading } = useSelector(
    (state) => state.loader
  )

  const limit = 28

  const onGamePlayRedirect = useCallback((game) => {
    const gameName = game.gameName.toLowerCase().replace(/\s+/g, '-')
    if (isLoggedIn) {
      history?.push(`/casino/play-game/${gameName}`, { game, demo: false })
    } else if (game.hasDemo) {
      history?.push(`/casino/play-game/${gameName}`, { game, demo: true })
    } else {
      openWarningToaster({ message: t('LoginRequired') })
    }
  }, [])

  const fetchMore = () => {
    if (isLoggedIn) {
      dispatch(
        getSearchedGames({
          data: {
            name: searchGame,
            limit,
            offset: filteredGames?.rows?.length,
            userId: user?.id,
            type: gameCategory
          }
        })
      )
    } else {
      dispatch(
        getSearchedGames({
          data: {
            name: searchGame,
            limit,
            offset: filteredGames?.rows?.length,
            type: gameCategory
          }
        })
      )
    }
  }

  useEffect(() => {
    if (searchGame.length >= 1 && tab === CASINO_TABS.LOBBY) {
      window.scrollTo({ top: 500, left: 0, behavior: 'smooth' })
      if (isLoggedIn) {
        if (gameCategory === GAME_CATEGORY.FAVOURITE) {
          dispatch(
            getAllFavouriteGames({
              data: { limit, offset: 0, provider, name: searchGame }
            })
          )
        } else {
          dispatch(
            getSearchedGames({
              data: {
                name: searchGame,
                limit,
                offset: 0,
                userId: user?.id,
                type: gameCategory
              }
            })
          )
        }
      } else {
        dispatch(
          getSearchedGames({
            data: {
              name: searchGame,
              limit,
              offset: 0,
              type: gameCategory
            }
          })
        )
      }
    }
    if (searchGame === '') {
      dispatch(setFilteredGames(null))
    }
  }, [searchGame])

  return (
    <div className='view-all-page-wrap'>
      <section className='global-casino-section'>
        {(filteredGames?.count === 0 && searchGame.length > 1)
          ? <ContentNotFound message={t('noMatchesFound')} />
          : (
            <div className='view-all-card-wrap'>
              {filteredGames?.rows?.map((game, idx) => {
                return (
                  <div key={game?.casinoGameId} className='view-card'>
                    <div className='theme-card-wrap'>
                      <div className='theme-card'>
                        <div className='casino-img-wrap'>
                          <GameImg imgSrc={game?.image} />
                          <div
                            className='card-overlay'
                            onClick={(e) => {
                              e.stopPropagation()
                              onGamePlayRedirect(game)
                            }}
                          >
                            <h4>{t('bannerContentPlayNow')}</h4>
                            <p>$1,130.33</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            )}
      </section>
      {loading && <Loader variant={LOADER_HANDLER_TYPES.content} />}

      <div className='d-flex justify-content-center align-items-center mt-4'>
        <div>
          <button
            className={`btn btn-secondary ${(filteredGames?.rows?.length < filteredGames?.count) ? '' : 'd-none'}`}
            disabled={!(filteredGames?.rows?.length < filteredGames?.count)}
            onClick={() => {
              if (filteredGames?.rows?.length < filteredGames?.count) {
                fetchMore()
              }
            }}
          >
            {t('loadMore')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(FilteredGames)
